<div class="flex flex-col h-full">
  @if (loading) {
    <maximizer-loader type="legacy"></maximizer-loader>
  }

  @if (form) {
    <div class="flex flex-col h-full overflow-hidden">
      <div class="flex-1 overflow-y-auto scrollbar pb-4">
        <form
          class="flex flex-col p-4 text-caption space-y-2"
          [formGroup]="form.group"
        >
          <kendo-formfield>
            <kendo-label
              [for]="objective"
              [text]="
                'outlook.opportunity.name'
                  | translate
                    : {
                        label: 'outlook.entries.opportunity' | translate,
                      }
              "
              >*
            </kendo-label>

            <kendo-textbox
              formControlName="objective"
              #objective
              [maxlength]="253"
              required
            ></kendo-textbox>
            <kendo-formerror>
              @if (form.controls.objective.hasError('maxlength')) {
                {{
                  'outlook.forms.maxlength-error'
                    | translate
                      : {
                          count:
                            form.controls.objective.errors?.['maxlength']
                              ?.requiredLength,
                        }
                }}
              }

              @if (form.controls.objective.hasError('required')) {
                {{ 'outlook.forms.requiredField' | translate }}
              }
            </kendo-formerror>
          </kendo-formfield>

          <kendo-formfield>
            <kendo-label
              [text]="'outlook.opportunity.description' | translate"
            ></kendo-label>
            <kendo-textarea
              [rows]="6"
              resizable="vertical"
              formControlName="description"
            ></kendo-textarea>
          </kendo-formfield>

          <kendo-formfield>
            <kendo-label
              [text]="'outlook.opportunity.process' | translate"
            ></kendo-label>
            <kendo-dropdownlist
              [data]="configuration.process"
              (valueChange)="handleProcessChange($event)"
              valueField="id"
              textField="name"
              fillMode="solid"
              formControlName="processId"
              [valuePrimitive]="true"
            >
            </kendo-dropdownlist>
          </kendo-formfield>

          <kendo-formfield>
            <kendo-label
              [text]="'outlook.opportunity.stage' | translate"
            ></kendo-label>
            <kendo-dropdownlist
              [data]="configuration.stages"
              valueField="id"
              textField="name"
              fillMode="solid"
              formControlName="stageId"
              [valuePrimitive]="true"
            >
            </kendo-dropdownlist>
          </kendo-formfield>

          <kendo-formfield>
            <kendo-label
              [for]="closeDate"
              [text]="'outlook.opportunity.estimatedCloseDate' | translate"
            >
            </kendo-label>
            <kendo-datepicker
              #closeDate
              formControlName="closeDate"
              placeholder=""
              [format]="fullFormat"
              calendarType="classic"
            >
            </kendo-datepicker>
          </kendo-formfield>

          <kendo-formfield>
            <kendo-label
              [for]="companyName"
              [text]="
                'outlook.opportunity.companyIndividual'
                  | translate
                    : {
                        label: 'individual' | translateVertical,
                      }
              "
            >
            </kendo-label>

            <kendo-textbox
              formControlName="companyName"
              #companyName
              [readonly]="true"
              class="bg-neutral-10"
            ></kendo-textbox>
          </kendo-formfield>

          <kendo-formfield>
            <kendo-label
              [for]="primaryContact"
              [text]="'outlook.opportunity.primaryContact' | translate"
            >
            </kendo-label>

            <kendo-autocomplete
              [filterable]="true"
              (filterChange)="handlePrimaryContactFilterChange($event)"
              (valueChange)="handlePrimaryContactValueChange($event)"
              [data]="abEntryList"
              formControlName="abEntryName"
              [loading]="autocompleteLoading"
              #primaryContact
              valueField="name"
            >
            </kendo-autocomplete>
          </kendo-formfield>

          @if (form.value.status === opportunityStatus.Won) {
            <kendo-formfield>
              <kendo-label
                [for]="actualRevenue"
                [text]="'outlook.opportunity.revenue' | translate"
              ></kendo-label>

              <kendo-numerictextbox
                formControlName="actualRevenue"
                format="#.##"
                #actualRevenue
                [spinners]="false"
                [changeValueOnScroll]="false"
              ></kendo-numerictextbox>
            </kendo-formfield>
          } @else {
            <kendo-formfield>
              <kendo-label
                [for]="forecastRevenue"
                [text]="'outlook.opportunity.forecastRevenue' | translate"
              ></kendo-label>

              <kendo-numerictextbox
                formControlName="forecastRevenue"
                format="#.##"
                #forecastRevenue
                [spinners]="false"
                [changeValueOnScroll]="false"
              ></kendo-numerictextbox>
            </kendo-formfield>
          }

          <kendo-formfield>
            <kendo-label
              [for]="cost"
              [text]="'outlook.opportunity.cost' | translate"
            ></kendo-label>

            <kendo-numerictextbox
              formControlName="cost"
              format="#.##"
              #cost
              [spinners]="false"
              [changeValueOnScroll]="false"
            ></kendo-numerictextbox>
          </kendo-formfield>

          <kendo-formfield>
            <kendo-label
              [text]="'outlook.opportunity.status' | translate"
            ></kendo-label>
            <kendo-dropdownlist
              [data]="configuration.statuses"
              textField="name"
              valueField="id"
              fillMode="solid"
              formControlName="status"
              [valuePrimitive]="true"
              (valueChange)="handleStatusChange($event)"
            >
            </kendo-dropdownlist>
          </kendo-formfield>
        </form>
      </div>

      <div class="bg-neutral-5 z-40 flex justify-end gap-2 p-2">
        <button
          kendoButton
          id="outlook-opportunity-ui-addOpportunity-cancel"
          class="uppercase"
          themeColor="primary"
          fillMode="flat"
          (click)="cancel()"
          [disabled]="loading"
        >
          {{ 'outlook.buttons.cancel' | translate }}
        </button>
        <button
          kendoButton
          id="outlook-opportunity-ui-addOpportunity-save"
          class="uppercase"
          themeColor="primary"
          [disabled]="!canSave"
          (click)="save()"
        >
          {{ 'outlook.buttons.save' | translate }}
        </button>
      </div>
    </div>
  }
</div>

<maximizer-outlook-notification
  #notification
  [closable]="true"
></maximizer-outlook-notification>
